//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HeadNavigation from '@common/head-navigation'
import contentInfo from '../../../assets/js/protocol-config'
const titleMap = {
  privateInfo: '隐私政策',
  profile: '用户协议',
  newProfile: '用户协议',
  newPrivateInfo: '隐私政策',
  childrenProfile: '儿童用户协议',
  childrenPrivateInfo: '儿童隐私政策'
}

export default {
  components: {
    HeadNavigation
  },
  methods: {
    leftBtn () {
      if (this.protocolType === 'profile') {
        this.protocolType = 'newProfile'
        this.$refs['boxContent'].scrollTo({
          top: 0,
          behavior: 'instant'
        })
      } else if (this.protocolType === 'privateInfo') {
        this.protocolType = 'newPrivateInfo'
        this.$refs['boxContent'].scrollTo({
          top: 0,
          behavior: 'instant'
        })
      } else {
        this.$emit('hide')
      }
    },
    toOld () {
      console.warn(this.$refs['boxContent'])
      if (this.protocolType === 'newProfile') {
        this.protocolType = 'profile'
        this.$refs['boxContent'].scrollTo({
          top: 0,
          behavior: 'instant'
        })
      } else if (this.protocolType === 'newPrivateInfo') {
        this.protocolType = 'privateInfo'
        this.$refs['boxContent'].scrollTo({
          top: 0,
          behavior: 'instant'
        })
      }
    },
    toggleBody (isShow = false) {
      console.warn('chuagnjian le ')
      if (isShow) {
        console.warn('一处吟唱')
        document.body.style.height = '100vh'
        document.body.style['overflow-y'] = 'hidden'
      } else {
        document.body.style.height = 'unset'
        document.body.style['overflow-y'] = 'auto'
      }
    }
  },
  props: {
    protocolType: {}
  },
  computed: {
    title () {
      return titleMap[this.protocolType] || ''
    }
  },
  data () {
    return {
      contentInfo: contentInfo
    }
  },
  mounted () {
    this.toggleBody(true)
  },
  beforeDestroy () {
    this.toggleBody()
  }
}



// WEBPACK FOOTER //
// ./src/plugin/LeonSimpleLogin/src/user-protocol.vue